import { useState } from "react";
import { useGetVendorContactsQuery } from "../../store/apiSlices/vendorContacts";
import CustomModal from "../DealTracker/CustomModal";
import { CrossIcon, EditIcon } from "../Icons";
import ContactForm from "./ContactForm";

export default function ChatHeader({ contactId }: { contactId: string }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const { data: contacts } = useGetVendorContactsQuery();

  const contact =
    contacts && contactId
      ? contacts.find((c) => c.id === parseInt(contactId)) || null
      : null;

  return (
    <>
      {contact && (
        <header className="px-4 py-3 border-b border-gray-200 flex items-center gap-3">
          {/* Avatar */}
          <div className="w-10 h-10 rounded-full bg-custom-blue-medium flex items-center justify-center text-white font-semibold">
            {contact.name.charAt(0)}
          </div>

          {/* Contact Info */}
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-gray-800">
                {contact.name}
              </span>
              <button
                type="button"
                className="p-1 rounded-lg hover:bg-gray-100 hover:scale-95 hover:text-custom-blue-medium"
                onClick={toggleModal}
              >
                <EditIcon className="size-4" />
              </button>
            </div>
            <span className="text-xs text-gray-500">{contact.company}</span>
            <span className="text-xs text-gray-400">{contact.email}</span>
          </div>
        </header>
      )}

      <CustomModal
        open={isModalOpen}
        onClose={toggleModal}
        className="bg-white rounded-xl shadow-xl p-6 max-w-xl w-full "
      >
        <button onClick={toggleModal} className="float-end hover:scale-95">
          <CrossIcon className="size-6" />
        </button>
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">
            Update Contact
          </h2>
          <ContactForm toggleModal={toggleModal} contactId={contactId} />
        </div>
      </CustomModal>
    </>
  );
}
